import React from 'react'
import prettysize from '../../../utils'

import {
  Modal,
  Icon,
  Select,
  Cascader,
  Input
} from 'antd'
import './styles.scss'

export default ({
  visible,
  dirs,
  profiles,
  file,
  definitions,
  profileId,
  onDestChange,
  onProfileChange,
  onDefChange,
  loadDirs,
  onCancel,
  onEncode,
  pricePerGB
}) =>
    (
        <Modal
            title='Hybrik Video Encoding'
            className='modal-encoding'
            visible={visible}
            onOk={onEncode.bind(null, file)}
            onCancel={onCancel}
            cancelText='Cancel'
            okText='Encode'>

            <div className='hybrik-modal rowWrap'>
                <span>Select encoding profile and the destination</span>
                <div className='presets'>
                    <Select
                        placeholder='Select profile'
                        style={{width: 120}}
                        onChange={onProfileChange}
                    >
                        {profiles.map(profile =>
                            <Select.Option
                                value={profile.id}
                                key={profile.id}
                            >
                                {profile.name}
                            </Select.Option>
                        )}
                    </Select>
                    <Cascader
                        placeholder='Select destination'
                        expandTrigger='hover'
                        options={dirs}
                        onChange={onDestChange}
                        loadData={loadDirs}
                        changeOnSelect
                    />
                </div>
                <div className={'items'}>
                    <div className='item columnWrap'>
                        {file.type === 'FS_FILE_TYPE_FILE'
                            ? <Icon type='file-text'/>
                            : <Icon type='folder'/>}
                        <div>
                            <span>{file.basename} </span>
                            <div className={'properties'}>
                                <span>{prettysize(file.size)}</span>
                                <span>
                    {'$' + (pricePerGB * (file.size / (1024 * 1024 * 1024))).toFixed(3)}
                  </span>
                            </div>
                        </div>
                    </div>
                </div>
                {
                    definitions &&
                    <div className='input-group'>
                        <span>Please fill job definitions</span>
                        {
                            Object.keys(definitions).map((d, i) => (
                                <Input
                                    key={i}
                                    name={d}
                                    addonBefore={d}
                                    value={definitions[d]}
                                    onChange={onDefChange}
                                />
                            ))
                        }
                    </div>
                }
            </div>
        </Modal>
    )
